'use client';

import { X } from 'lucide-react';
import { useState, useEffect } from 'react';
import ExplorePopupForm from './ExplorePopupForm';

const ExplorePopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 15000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (showPopup) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    // Cleanup function to reset overflow when component unmounts
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showPopup]);

  if (!showPopup) return null;

  return (
    <div className="fixed inset-0 flex animate-fade-in-down items-center justify-center bg-black/50 backdrop-blur-sm z-50">
      <div className="max-w-[900px] md:max-h-[95vh] max-h-[85vh] overflow-scroll no-scrollbar mx-2 md:mx-20 bg-[#020c0d]  border-teal-300/50 relative border rounded-[1.375rem] text-white w-full px-4 sm:px-7 pb-4 pt-10 md:py-16 md:px-14">
        <div className="space-y-4">
          <h5 className="md:text-[32px] text-[20px] max-w-[72.938rem] mx-auto font-bold text-center  drop-shadow-[0px_0px_6px_rgba(255,255,255,0.5)]">
            Get 20 hours of free development and consulting (a $1,000 value)
          </h5>
          <p className="max-w-[54.5rem] text-[16px] font-normal leading-[1.716rem] text-gray-300 mx-auto text-center">
            Get 20 hours of free consulting and development hours across all our
            services. Book a meeting now to claim your offer!
          </p>
        </div>
        <ExplorePopupForm setShowPopup={setShowPopup} />
        <button
          onClick={() => setShowPopup(false)}
          className="absolute top-5 right-5"
        >
          <div className="inset-0 rounded-full shadow-[0px_2px_28px_0px_#ffffff29] h-10 w-10">
            <div
              className="absolute inset-0 rounded-full border-[3px] border-transparent bg-clip-padding p-[3px] box-content"
              style={{
                background:
                  'linear-gradient(to bottom, rgba(255,255,255,0.7) 0%, rgba(255,255,255,0.3) 50%, rgba(255,255,255,0.3) 100%) border-box',
              }}
            >
              <div
                className="absolute flex items-center
               justify-center inset-0 rounded-full bg-[#020c0d]"
              >
                <X className="hover:scale-105 lg:h-6 lg:w-6 w-4 h-4 duration-300 transition-all ease-in-out text-teal-300" />
              </div>
            </div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default ExplorePopup;
